module.exports = __webpack_public_path__ + "static/img/1.f99a21a7.png";